import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgThumbUp = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M14 31H9V20H14",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14 20L17 9C17.7956 9 18.5587 9.31607 19.1213 9.87868C19.6839 10.4413 20 11.2044 20 12V18H27.5C27.9325 18 28.3599 18.0936 28.7529 18.2742C29.1459 18.4549 29.4951 18.7183 29.7767 19.0466C30.0584 19.3749 30.2657 19.7601 30.3845 20.176C30.5033 20.5919 30.5307 21.0285 30.465 21.456L29.388 28.456C29.2792 29.1638 28.9207 29.8093 28.3775 30.2758C27.8343 30.7424 27.1421 30.9993 26.426 31H14V20Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10,
		strokeLinecap: "square"
	})]
});
const ForwardRef = forwardRef(SvgThumbUp);
export default ForwardRef;
